import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Portal from 'atoms/Portal/Portal';
import PageGuideDismissedTemplate from 'organisms/PageGuideDismissedTemplate/PageGuideDismissedTemplate';
import PageGuideTemplate from 'organisms/PageGuideTemplate/PageGuideTemplate';
import { dismissAllPageGuides, dismissPageGuide, openPageGuide, selectPageGuides, } from 'store/layoutSlice';
import getPageGuideKey from 'utils/getPageGuideKey';
import styles from './PageGuideManager.module.scss';
import usePageGuideContent from './usePageGuideContent';
/**
 * Mounted once in Layout. Shows the current page's "Fashionapps guide" card
 * automatically the first time a page is visited (until dismissed), and
 * re-opens it on demand when a page's help button dispatches openPageGuide.
 */
function PageGuideManager() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const pageKey = getPageGuideKey(location.pathname);
    const { dismissedPages, allDismissed, openPageKey } = useSelector(selectPageGuides);
    const content = usePageGuideContent(pageKey);
    const [showDismissedInfo, setShowDismissedInfo] = useState(false);
    useEffect(() => {
        if (pageKey && !allDismissed && !dismissedPages.includes(pageKey)) {
            dispatch(openPageGuide(pageKey));
        }
        // Hide the "guide turned off" card again once the user navigates away,
        // and only re-evaluate the "show automatically" behavior on page change.
        setShowDismissedInfo(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageKey]);
    if (showDismissedInfo) {
        return (React.createElement(Portal, null,
            React.createElement("div", { className: styles.wrap },
                React.createElement(PageGuideDismissedTemplate, { onOpenHelpCenter: () => navigate('/help'), onClose: () => setShowDismissedInfo(false) }))));
    }
    if (!pageKey || !content || openPageKey !== pageKey) {
        return null;
    }
    return (React.createElement(Portal, null,
        React.createElement("div", { className: styles.wrap },
            React.createElement(PageGuideTemplate, { title: content.title, body: content.body, onDismissAll: () => {
                    dispatch(dismissAllPageGuides());
                    setShowDismissedInfo(true);
                }, onDone: () => dispatch(dismissPageGuide(pageKey)) }))));
}
export default PageGuideManager;
